module.exports = __webpack_public_path__ + "img/product-system.ec85e324.jpg";